import { EnvEnum } from 'shared-domain';

export const environment = {
  service: 'defacto-resumeflow-app',
  env: EnvEnum.production,
  baseUrlApp: 'https://kyb-kyc.getdefacto.com',
  baseUrlApi: 'https://defacto-resumeflow-api.onrender.com',
};
